// Remove special charaters to be used in URLs

export default function formatUrlPath(urlString) {
	if (typeof urlString !== 'string') {
		return urlString;
	} else {
		urlString = urlString
      .replace(/^\s+|\s+$/g, '')
      .toLowerCase()
			.replace(/&/g, 'and')
			.replace(/[^a-zA-Z0-9 -]/g, '')
			.replace(/\s/g, '-')
      .replace(/-+/g, '-');
		return urlString;
	}
}
